import { AddHighlightTypes } from './utils.types';

export const addHighlightBold = (string: AddHighlightTypes) => {
  const regexHighlightBold = string?.replace(
    /\[([\s\S]*?)\]/g,
    '<span style="font-weight: 500; text-wrap: pretty; display: inline-block;"}>$1</span>',
  );
  return regexHighlightBold;
};

export default addHighlightBold;
